import api from "services/api";
import { toSearchFilter } from "utils";
import { API_URL_VERSION } from "constants/environment";

export const ENDPOINT_PARAMETERS = API_URL_VERSION + "parametros";
export const ENDPOINT_PARAMETERS_LIST = ENDPOINT_PARAMETERS + "/listar";

export const parametersService = {
  list: async (params) => {
    try {
      const response = await api.post(ENDPOINT_PARAMETERS_LIST, toSearchFilter(params));
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.parameter.messages.errors.list";
    }
  },

  create: async (data) => {
    try {
      const response = await api.post(ENDPOINT_PARAMETERS, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.parameter.messages.errors.create";
    }
  },

  find: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_PARAMETERS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.parameter.messages.errors.find";
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`${ENDPOINT_PARAMETERS}/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.parameter.messages.errors.update";
    }
  },
};
